import { render, staticRenderFns } from "./DialogMerge.vue?vue&type=template&id=720210c5"
import script from "./DialogMerge.vue?vue&type=script&lang=js"
export * from "./DialogMerge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('720210c5')) {
      api.createRecord('720210c5', component.options)
    } else {
      api.reload('720210c5', component.options)
    }
    module.hot.accept("./DialogMerge.vue?vue&type=template&id=720210c5", function () {
      api.rerender('720210c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/candidates/components/DialogMerge.vue"
export default component.exports